import { ChangeEvent } from 'react';

export const lowerCaseTransform = {
  mapper: (event: ChangeEvent<HTMLInputElement>) => event.target.value.toLowerCase(),
};
